/* ------------------------------------------------------------------------------
 *
 *  # Resource Loader Module
 *
 *  Dynamic resource loading functionality
 *
 * ---------------------------------------------------------------------------- */

// Load resources dynamically 
export function loadResources(resources, initComponents) {
    const loadResource = (resource) => {
        return new Promise((resolve, reject) => {
            let element;
            let url = new URL(resource, window.location.origin);
            if (resource.endsWith('.css')) {
                element = document.createElement('link');
                element.setAttribute('href', `${url}?v=${new Date().getTime()}`);
                element.setAttribute('rel', 'stylesheet');
                element.onload = () => {
                    console.log(`CSS loaded: ${resource}`);
                    resolve();
                };
                element.onerror = () => {
                    console.error(`Failed to load CSS: ${resource}`);
                    reject(new Error(`Failed to load CSS: ${resource}`));
                };
            } else {
                element = document.createElement('script');
                element.setAttribute('src', resource);
                element.onload = () => {
                    console.log(`Script loaded: ${resource}`);
                    resolve();
                };
                element.onerror = () => {
                    console.error(`Failed to load script: ${resource}`);
                    reject(new Error(`Failed to load script: ${resource}`));
                };
            }
            document.head.appendChild(element);
        });
    };
    let chain = Promise.resolve();
    for (const element of resources) {
        chain = chain.then(() => loadResource(element));
    }
    chain.then(() => {
        if (initComponents) {
            setTimeout(() => {
                if (typeof themeSwitcher !== 'undefined') {
                    themeSwitcher.init();
                }
                //D3Streamgraph.init();
            }, 20);
        }
    }).catch(error => {
        console.error('Error loading resources:', error);
    });
}
